import { Avatar, Typography } from '@mui/material';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { stringAvatar } from '../../../utils/common.util';
import { getRelativeDateFromNow } from '../../../utils/date.util';
import messages from '../messages';
import NotificationIgnoreButton from './NotificationIgnoreButton';
import { FlexTextContainer } from '../../common/ui/Container';
import EventLink from '../../common/EventLink';

function TeamSizeReachedNotification({
  event,
  status,
  createdAt,
  updatedAt,
  onIgnore,
  disableIgnore,
  canIgnore,
}) {
  const { name, avatarUrl, id } = event;
  const { eventGroupId } = event;
  const teamAvatar = stringAvatar(name);
  const relativeDateInSecond = getRelativeDateFromNow(updatedAt || createdAt);
  //   const notificationText =
  return (
    <FlexTextContainer sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Avatar sx={teamAvatar.sx} src={avatarUrl}>
        {teamAvatar.children}
      </Avatar>
      <Typography variant="subtitle">
        <FormattedMessage
          id={messages.onlyMale.id}
          defaultMessage={messages.teamSizeReached.defaultMessage}
          values={{
            // eslint-disable-next-line react/no-unstable-nested-components
            event: () => (
              <Typography component="span">
                <EventLink
                  displayName={name}
                  id={id}
                  eventGroupId={eventGroupId}
                />
              </Typography>
            ),
            name,
          }}
        />
      </Typography>
      <Typography variant="caption">{relativeDateInSecond}</Typography>
      {status === 'active' && canIgnore && (
        <NotificationIgnoreButton
          onClickHandler={onIgnore}
          loading={disableIgnore}
        ></NotificationIgnoreButton>
      )}
    </FlexTextContainer>
  );
}

export default memo(TeamSizeReachedNotification);
